import Api from "../api";

class Platform {
  addPlaform = async (data) => {
    const { body } = await Api.post("platform", data);
    return body;
  };

  fetchPlatform = async (id) => {
    const { body } = await Api.get(`platform/${id}`);
    return body;
  };

  updatePlatform = async (id, data, params = {}) => {
    const { body } = await Api.put(`platform/${id}`, data, params);
    return body;
  };

  fetchPlatforms = async (
    params = { order_by: "id", order_direction: "ASC" }
  ) => {
    const { body } = await Api.get(`platforms`, null, params);
    return body;
  };

  deletePlatform = async (id, params = {}) => {
    const { body } = await Api.destroy(`platform/${id}`, {}, params);
    return body;
  };
}
// eslint-disable-next-line
export default new Platform();
